// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instant-play-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}
.instant-play-list .instant-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 32px;
  gap: 14px;
}
.instant-play-list .instant-header .divider {
  display: flex;
  padding: 16px 0;
  align-items: center;
  align-self: stretch;
}
.instant-play-list .instant-header .instant-header-text {
  display: flex;
  align-items: start;
  width: 100%;
  font-size: 28px;
  gap: 24px;
}
.instant-play-list .instant-header .instant-header-text .nkl-typography {
  flex: 1 1 auto;
  min-width: 0;
}
.instant-play-list .instant-header .instant-header-text .instant-tag {
  margin-left: auto;
  flex: 0 0 auto;
  white-space: nowrap;
}
.instant-play-list .instant-header .instant-header-text .instant-tag .nkl-tag,
.instant-play-list .instant-header .instant-header-text .instant-tag .nkl-tag-color {
  white-space: nowrap;
}
/*  MOBILE ONLY */
@media (max-width: 768px) {
  .instant-play-list .instant-header .instant-header-text {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .instant-play-list .instant-header .instant-header-text .instant-tag {
    margin-left: 0;
    padding-top: 4px;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
